import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import lodash from 'lodash';
import { validateField } from './../../../utilities/validation/validator';

export const checkUserStatus = createAsyncThunk('genericVasBlock/checkUserStatus', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('checkUserStatus', [data.blockId, data.subscriberNo]);
    return result;
  } catch (error) {
    return error;
  }
});

export const saveGenericVAS = createAsyncThunk('genericVasBlock/saveGenericVAS', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('saveGenericVAS', [
      data.captchaToken,
      data.blockId,
      data.subscriberNo,
      data.socType,
      data.email,
      data.socName,
      data.isServiceAccessFormChecked
    ]);
    return result;
  } catch (error) {
    return error;
  }
});

export const sendEmailHaveEsim = createAsyncThunk('genericVasBlock/sendEmailHaveEsim', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('sendEmailHaveEsim', [
      data.captchaToken,
      data.blockId,
      data.subscriberNo,
      data.socType,
      data.email,
    ]);
    return result;
  } catch (error) {
    return error;
  }
});


const initialState = {
  isPrivate: true,
  isTermsAccepted: false,
  isShowConfirmTermsMsg: false,
  isShowConfirmPopUpTermsMsg: false,
  errorConfirmPopUpTermsMsg: '',
  error: { isDisplay: false, id: 0},
  isShowSuccessView: false,
  isOpenForCalls: false,
  serviceAlreadyExist: false,
  isShowMainView: false,
  numberOfSubscribers: 0,
  userMobileNumbers: [],
  email: {
    email: '',
    valid: '',
    errors: {
      email: '',
    },
    rules: {},
  },
  isValidEmail: false,
  isInstallSocsClicked: false,
  isSendEsimEmailSuccess: false,
  isShowEsimError: false,
};

const genericVasBlockSlice = createSlice({
  name: 'genericVasBlock',
  initialState: initialState,

  reducers: {
    resetState: (state) => initialState,
    reportAnalytics: (state, action) => { },
    setTermAgreement: {
      reducer(state, action) {
        state.isTermsAccepted = action.payload;
        if (action.payload) {
          state.isShowConfirmTermsMsg = false;
          state.isShowConfirmPopUpTermsMsg = false;
        }
      },
    },
    setIsShowConfirmTermsMsg: {
      reducer(state, action) {
        state.isShowConfirmTermsMsg = action.payload;
      },
    },
    setIsShowConfirmPopUpTermsMsg: (state, action) => {
      state.isShowConfirmPopUpTermsMsg = action.payload;
    },
    setErrorConfirmPopUpTermsMsg: (state, action) => {
      state.errorConfirmPopUpTermsMsg = action.payload;
    },
    setUserMobileNumbers: (state, action) => {
      state.userMobileNumbers = action.payload;
    },
    setIsValidEmail: (state, action) => {
      state.isValidEmail = action.payload;
    },
    changeEmailInputHandler: {
      reducer(state, action) {
        const formName = action.payload.formName;
        state[formName] = action.payload.validate;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return { payload: { validate: validate, formName: name } };
      },
    },
    setIsInstallSocsClicked: (state, action) => {
      state.isInstallSocsClicked = action.payload;
    },
    reportDWH: (state, action) => { },
  },
  extraReducers: {
    [saveGenericVAS.fulfilled]: (state, action) => {
      if (action.payload.errorCode != undefined) {
        state.error.isDisplay = true;
        state.isShowMainView = false;
        if (action.payload.errorCode == 1065 || action.payload.errorCode == 1066) {
          state.error.id = action.payload.errorCode;
        } else {
          state.error.id = 1060;
        }
      }

      if (action.payload.Body?.codeError == 'ServiceAccessFormError') {
        state.error.isDisplay = true;
        state.isShowMainView = false;
        state.error.id = 1060;
        return;
      }

      if (action.payload.Body) {
        state.isShowMainView = false;
        state.isShowSuccessView = true;
        state.email.email = action.payload;
      }
    },
    [checkUserStatus.fulfilled]: (state, action) => {
      if (action.payload.errorCode != undefined) {
        state.isShowSuccessView = false;
        state.error.isDisplay = true;
        if (action.payload.errorCode == 1061 || action.payload.errorCode == 1062 || action.payload.errorCode == 1063 || action.payload.errorCode == 1068) {
          state.error.id = action.payload.errorCode;
        } else {
          state.error.id = 1060;
        }
      }
      if (action.payload.Body) {
        state.isShowMainView = true;
        state.numberOfSubscribers = action.payload.Body.numberOfSubscribers;
        state.isPrivate = action.payload.Body.type == 'PRIVATE';
        state.serviceAlreadyExist = action.payload.Body.serviceAlreadyExist;
        if (action.payload.Body.haveAddEsimToDay) {
          state.isShowMainView = false;
          state.isSendEsimEmailSuccess = false;
          state.isShowEsimError = true;
        }
        state.isOpenForCalls = action.payload.Body.isOpenForCalls;
      }
    },
    [sendEmailHaveEsim.fulfilled]: (state, action) => {
      if (action.payload.errorCode != undefined || !action.payload.Body?.success) {
        state.isShowEsimError = false;
        state.isShowSuccessView = false;
        state.error.isDisplay = true;
        if (action.payload.errorCode == 1061 || action.payload.errorCode == 1062 || action.payload.errorCode == 1063) {
          state.error.id = action.payload.errorCode;
        } else {
          state.error.id = 1060;
        }
      } else if (action.payload.Body?.success) {
        state.isSendEsimEmailSuccess = true;
      }
    },
  },
});

export const {
  resetState,
  setTermAgreement,
  setIsShowConfirmTermsMsg,
  setIsShowConfirmPopUpTermsMsg,
  setErrorConfirmPopUpTermsMsg,
  reportAnalytics,
  setUserMobileNumbers,
  changeEmailInputHandler,
  setIsValidEmail,
  setIsInstallSocsClicked,
  reportDWH
} = genericVasBlockSlice.actions;

export default genericVasBlockSlice.reducer;
